import config from "../config";

export const BaseUrl = config.BASE_URL;

export const AppMaster = "/user/master";
export const SignOut = "/user/logout";
export const GetUserJobsiteDropDown = "/user/dropdown-jobsite";
export const GetUsers = "/user";
export const DeleteServiceHistory = "/fieldofservice/delete-service";
export const EditTool = "/fieldofservice/edit-tool";
export const UserStatusUpdate = "/user/update-status";
export const OrganizationStatusUpdate = "/user/update-oranisations-status";
export const SubOrganizationStatusUpdate =
  "/user/update-sub-oranisations-status";
export const GetUsersList = (searchText = "", offset = 0, limit = 20) =>
  `/user?q=${searchText}&offset=${offset}&limit=${limit}`;

export const GetToolsList = (searchText = "", offset = 0, limit = 20) =>
  `/fieldofservice/list-tools-for-service?q=${searchText}&offset=${offset}&limit=${limit}`;

export const GetServiceHistorysList = (
  searchText = "",
  offset = 0,
  limit = 20,
) =>
  `/fieldofservice/get-service-history?q=${searchText}&offset=${offset}&limit=${limit}`;

export const GetToolDetailsByID = (toolId) =>
  `/fieldofservice/get-tool?_id=${toolId}`;

export const GetServiceDetailsByID = (toolId) =>
  `/fieldofservice/get-service-details?_id=${toolId}`;

export const UpdateServiceHistory = "/fieldofservice/update-service-details";

export const GetInviteUsers = (searchText, offset, limit) =>
  `/user/invited-users?q=${searchText}&offset=${offset}&limit=${limit}`;

export const GetManageOrganizations = "/user/manage-organisation";

export const GetManageSubOrganizations = (orgId) =>
  `/user/manage-sub-organisation?organisationId=${orgId}`;

export const GetProfileData = "/user/get-user";
export const GetUserById = "/user/get-user-by-id?";
export const GetOrder = "/order/order-info";
export const UpdateUser = "/user/update-user-by-id";

export const UploadFile = "/file/upload-file";
export const ReturnValidate = "/order/validate-ordered-tools";
export const ValidateReturnTool = "/order/validate-returned-tools";

export const GetUsersCSV = (searchText) =>
  `/user/export-users?invitedUser=false&flag=1&q=${searchText}`;

export const GetUsersPDF = (searchText) =>
  `/user/export-users?invitedUser=false&flag=0&q=${searchText}`;

export const GetServiceHistoryCSV = `/fieldofservice/export-service-history?flag=1`;

export const GetServiceHistoryPDF = `/fieldofservice/export-service-history?flag=0`;

export const GetServiceHistoryDetailCSV = (servieId) =>
  `/fieldofservice/export-service-details?flag=1&_id=${servieId}`;

export const GetServiceHistoryDetailPDF = (servieId) =>
  `/fieldofservice/export-service-details?flag=0&_id=${servieId}`;

export const GetOrganizationsCSV = "/user/export-manage-organisation?flag=1";

export const GetOrganizationsPDF = "/user/export-manage-organisation?flag=0";

export const GetSubOrganizationsCSV = (organisationId) =>
  `/user/export-manage-sub-organisation?flag=1&organisationId=${organisationId}`;

export const GetSubOrganizationsPDF = (organisationId) =>
  `/user/export-manage-sub-organisation?flag=0&organisationId=${organisationId}`;

export const GetorderViewPdf = "/order/export-order?flag=0";
export const GetorderViewCsv = "/order/export-order?flag=1";
export const GettoolViewPdf = "/order/export-order-items?flag=0";
export const GettoolViewCsv = "/order/export-order-items?flag=1";
export const GetExtentionPdf = "/order/export-reservation-extension?flag=0";
export const GetExtentionCsv = "/order/export-reservation-extension?flag=1";
export const GetWareHouseToolViewPdf = "/tool/export-tools?flag=0";
export const GetWareHouseToolViewCsv = "/tool/export-tools?flag=1";
export const GetWareHouseCategoryViewPdf = "/tool/export-group-tools?flag=0";
export const GetWareHouseCategoryViewCsv = "/tool/export-group-tools?flag=1";

export const ToolCategoryList = (searchText) =>
  `/tool/group-tools?q=${searchText}`;

export const AllToolCategoryList = "/tool/categories-dropdown";

export const AddToolCategories = "/tool/";
export const UpdateToolCategory = "/tool/update";

export const AddToolSerialNo = "/tool/add-serial";
export const UpdateToolSerialNo = "/tool/update-tool-serial-no";
export const WarehouseToolList = "/tool/get-all-tools";
// export const WarehouseAllToolList = (offset = 0, limit = 20) =>
//   `/tool/get-all-tools?offset=${offset}&limit=${limit}`;
export const WarehouseAllToolList = (searchText = "", offset = 0, limit = 20) =>
  `/tool/get-all-tools?q=${searchText}&offset=${offset}&limit=${limit}`;

export const ToolsList = "/tool";
export const ToolCategoriesList = "/tool/categories-dropdown";
export const GetToolCategoriesListByID = (orgId) =>
  `/tool/categories-dropdown?organisationId=${orgId}`;
export const ToolViewList = "/tool/tool-view-list";
export const ToolViewListV2 = "/tool/tool-view-list-v2";
export const ToolDetailsApi = "/tool/tool-detail";
export const ToolDetailBySerialApi = "/tool/serial-number-detail";
export const UpdateToolStatus = "/tool/update-status";
export const Checkout = "/cart/checkout";
export const CartList = "/cart";
export const EmptyCart = "/cart/empty-cart";
export const UserDashboard = "/user/dashboard";
export const GetUserRoles = "/user/get-roles";
export const GetUserTrades = "/user/get-trades";
export const GetOrganizations = "/user/organisations-dropdown";
export const GetSubOrganizations = "/user/get-sub-organisations";
export const GetSubOrganizationsByID = (orgId) =>
  `/user/get-sub-organisations-by-id?organisationId=${orgId}`;
export const GetOrganizationDetailsByID = (orgId) =>
  `/user/get-organisations-details?organisationId=${orgId}`;
export const OrderViewApi = `/order/bookings`;
export const deleteListApi = "/tool/delete-request-list";
export const cancelDeleteRequest = "/tool/delete-action";
export const deleteCategory = "/tool/delete";
export const ReservationExtension = `/order/reservation-extension`;
export const deletiondetailsApi = "/tool/deleteref-tools-list?deleteRef=";
export const deletetoolsApi = "/tool/delete-tool-request";
export const removetoolsApi = "/tool/remove-delete-request";
export const reportTool = "/tool/report-tool";
export const HistoryViewList = "/history";
export const addMultipleTools = "/tool/add-multiple-tools";
export const sampleFileDownload = "/uploads/add_multi_tool_sample.csv";
export const sampleMultiUserCsv = "/uploads/add_multi_user.csv";
export const addMultipleUser = "/user/add-multi-users";
export const exportReportBookingApi = "/report/export-bookings?flag=";
export const exportReportWarehouseApi = "/report/export-warehouse?flag=";
export const exportHistoryBookingApi = "/history/export-bookings?flag=";
export const exportHistoryWarehouseApi = "/history/export-warehouse?flag=";
export const exportHistoryFieldOfSearch =
  "/history/export-field-of-service?flag=";
export const exportHistoryUserApi = "/history/export-users?flag=";
export const exportHistoryProfileApi = "/history/export-profile?flag=";
export const exportDashboardApi = "/user/export-dashboard?flag=";
export const getThemes = "/theme-colour";

// Admin KPI Dashboard
export const DashboardWarehouse = "/dashboard/warehouse";
export const DashboardServicing = "/dashboard/service";
export const DashboardAssetExtension = "/dashboard/asset-extension";
export const DashboardMissingDamaged = "/dashboard/missing-damaged";
export const DashboardToolCategories = "/dashboard/tool-category";
export const Dashboard = "/dashboard";

export const getToolBySerialNumber = (value) =>
  `/tool/tool-by-serial?serialNumber=${value}`;

// made url with dynamic data
export const ListTool = (value) => `/tool?q=${value}`;

export const OrderRequestApproval = `/order/request-tool-approval`;
export const GetTwilioToken = "/message-center/get-token";
export const CreateConversation = "/message-center/create-chat";
export const UsersListForMessages = (
  offset = 0,
  limit = 20,
  remainingUrl = "",
) =>
  `/message-center/user-dropdown-message-center?offset=${offset}&limit=${limit}${remainingUrl}`;
export const UserConversations = (remainingUrl) =>
  `/message-center/user-conversations?${remainingUrl}`;
export const UsersMessageCenterDropdown = (
  remainingUrl = "",
  offset = 0,
  limit = 50,
) =>
  `/message-center/user-dropdown-message-center?offset=${offset}&limit=${limit}${remainingUrl}`;
export const CreateChat = "/message-center/create-chat";

// maps url
export const GetDeviceLocations = "/devices/locations";
export const GetDeviceData = "/devices/data";

//Device Activation
export const GetLinkedAsset = (serialNumber) =>
  `/tool/serial-number-detail?serialNumber=${serialNumber}`;
export const ActivateSim = (imei) =>
  `/devices/update-sim?imei=${imei}&targetStatus=ready`;
export const GetSimStatus = (imei) => `/devices/sim-status?imei=${imei}`;
export const GetDeviceDataOnly = (imei) => `/devices/data?imei=${imei}`;
export const LinkAsset = "/devices/link-asset";

export const UnlinkAsset = (imei, serialNumber) =>
  `/devices/link-asset?imei=${imei}&assetSerialNumber=${serialNumber}&unlink=true`;

export const getDeviceLocationHistory = (limit, offset) =>
  `/devices/location?limit=${limit}&offset=${offset}`;
export const getDeviceHistory = (limit, offset) =>
  `/devices/history?limit=${limit}&offset=${offset}`;

// tag Order Routes
export const getTagPrice = "/tags/tag-price";
export const shippingAddress = "/tags/address";
export const submitTagOrder = "/tags/create";
export const getPreviousSequence = "/tags/previous-sequence";
export const validateSequence = "/tags/validate-sequence";
export const markTagOrderPaid = "/tags/pay";
export const customTagRoute = "/tags/custom-tag";
export const tagOrdersList = "/tags/orders";
export const orderRoute = (orderId) => `/tags/order?orderId=${orderId}`;
export const tagOrders = "/tags/order";
export const organisationPlans = "/tags/plans";
export const requestNumberRoute = "/tags/request-number";
export const reorderTags = "/tags/tag-numbers";
export const approvePlan = "/tags/approve-plan";
export const GetServiceTemplates = "/servicing-template/list";
export const CreateServiceTemplate = "/servicing-template/create";
export const UpdateServiceTemplate = "/servicing-template/update";
export const DeleteServiceTemplate = "/servicing-template/delete";
export const GetTemplateHistoryById = (templateId) =>
  `/servicing-template/history?templateId=${templateId}`;
export const GetServiceReportHistoryById = (serviceReportId) =>
  `/fieldofservice/service-report-history?serviceReportId=${serviceReportId}`;
export const GetServiceReports = "/fieldofservice/service-reports";
export const ScheduleService = "/fieldofservice/schedule-service";
export const RescheduleService = "/fieldofservice/reschedule-service";
export const CancelService = "/fieldofservice/cancel-service";
export const GetServiceScheduleHistory = (serialNumber, queryString = "") =>
  `/fieldofservice/service-scheduling-history${queryString}`;
export const UpdateTemplateStatus = "/servicing-template/update-status";
export const GetNotifications = "/notifications";

// Legal Documents
export const GetActiveLegalDocuments = "/legal-documents?status=active";
export const AcceptLegalDocuments = "/legal-documents/accept";

// Help Centre
export const GetFaqCategories = "/help/categories";

export const GetFaqs = (page = 1, pageSize = 10) => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  return `/help/faqs?${params.toString()}`;
};

export const SearchHelpArticles = (search, page = 1, pageSize = 10) => {
  const params = new URLSearchParams();
  params.set("search", search);
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  return `/help/articles/search?${params.toString()}`;
};

export const GetHelpCategory = (categoryKey, search = "") => {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  const query = params.toString();
  return query
    ? `/help/categories/${categoryKey}?${query}`
    : `/help/categories/${categoryKey}`;
};

export const GetHelpArticle = (articleId) => `/help/articles/${articleId}`;

export const GetHelpMedia = (platform = "", type = "", subcategoryKey = "") => {
  const params = new URLSearchParams();
  if (platform) params.set("platform", platform);
  if (type) params.set("type", type);
  if (subcategoryKey) params.set("subcategoryKey", subcategoryKey);
  const query = params.toString();
  return query ? `/help/media?${query}` : "/help/media";
};
